export const TR_FR = {
  // SEO overhaul: directory, pagination, profile facts
  lawyers_level_label: "Tableau",
  lawyers_all_levels: "Tous les tableaux",
  lawyers_by_governorate: "Avocats par gouvernorat",
  lawyers_page_of: "Page {{page}} sur {{pages}}",
  lawyers_empty_level: "Aucun avocat de ce tableau dans ce gouvernorat.",
  pagination_label: "Pages",
  pagination_prev: "Précédent",
  pagination_next: "Suivant",
  breadcrumb_label: "Fil d'Ariane",
  profile_bar_level: "Tableau",
  profile_sworn_in: "Prestation de serment",
  profile_bar_section: "Section régionale",
  profile_office_address: "Adresse du cabinet",
  profile_city: "Gouvernorat",
  profile_other_lawyers: "Autres avocats ({{city}})",
  profile_claim: "Vous êtes cet avocat ? Revendiquez votre profil",
  // Questions & answers pages redesign
  qa_latest: "Dernières questions",
  qa_eyebrow: "Questions & réponses",
  qa_ask: "Poser une question",
  qa_ask_text: "Posez votre question aux avocats inscrits sur la plateforme.",
  qa_read_answers: "Voir les réponses",
  qa_no_answers: "Pas encore de réponse.",
  qa_no_answers_text: "Les avocats inscrits sur la plateforme peuvent répondre à cette question.",
  qa_lawyer_badge: "Avocat",
  qa_back: "Toutes les questions",
  qa_empty: "Aucune question publiée pour le moment.",
  qa_question_label: "Question",
  qa_answer_error: "Votre réponse n'a pas pu être publiée. Réessayez.",
  qa_save: "Enregistrer",
  // Lawyer dashboard redesign
  ldash_hello: "Bonjour, Maître {{name}}",
  ldash_lead: "Gérez vos demandes de rendez-vous, votre agenda et vos réponses au même endroit.",
  ldash_stat_pending: "Demandes en attente",
  ldash_pending_count: "{{count}} demandes en attente de votre réponse",
  ldash_public_profile: "Voir mon profil public",
  ldash_username_add: "Ajouter un nom d'utilisateur",
  ldash_username_placeholder: "Nom d'utilisateur unique",
  ldash_decline: "Refuser",
  ldash_confirm_accept: "Accepter ce rendez-vous ?",
  ldash_confirm_decline: "Refuser ce rendez-vous ?",
  ldash_empty_list: "Rien dans cette liste pour le moment.",
  manual_add: "Ajouter un rendez-vous",
  manual_lead: "Les demandes reçues sur AvoConsulte et les rendez-vous que vous ajoutez vous-même.",
  manual_client: "Client",
  manual_client_mode_mine: "Un de mes clients sur AvoConsulte",
  manual_client_mode_outside: "Client hors plateforme",
  manual_pick_client: "Choisir un client",
  manual_no_clients: "Vous n'avez pas encore de client sur AvoConsulte : ajoutez un client hors plateforme.",
  manual_client_name: "Nom du client",
  manual_client_phone: "Téléphone",
  manual_client_email: "E-mail (facultatif)",
  manual_contact: "Contact",
  manual_subject: "Objet",
  manual_date: "Date",
  manual_start: "Début",
  manual_end: "Fin",
  manual_type: "Type",
  manual_notes: "Notes (facultatif)",
  manual_save: "Enregistrer le rendez-vous",
  manual_saved: "Rendez-vous ajouté à votre agenda.",
  manual_hint_account: "Le client est prévenu par e-mail et voit le rendez-vous dans son espace.",
  manual_hint_outside: "Aucun e-mail n'est envoyé : le rendez-vous est noté dans votre agenda.",
  manual_tag: "Ajouté par vous",
  manual_err_SLOT_TAKEN: "Ce créneau chevauche un autre rendez-vous ou événement.",
  manual_err_BAD_TIME: "Choisissez un début à venir et une fin après le début.",
  manual_err_TOO_LONG: "Un rendez-vous dure au plus 12 heures.",
  manual_err_CLIENT_REQUIRED: "Indiquez le client.",
  manual_err_BAD_EMAIL: "Adresse e-mail invalide.",
  manual_err_SUBJECT_REQUIRED: "L'objet est obligatoire.",
  manual_err_NOT_YOUR_CLIENT: "Cette personne n'est pas un de vos clients.",
  manual_err_generic: "Le rendez-vous n'a pas pu être ajouté, veuillez réessayer.",
  appt_cancel: "Annuler le rendez-vous",
  appt_cancel_confirm: "Annuler ce rendez-vous ?",
  appt_cancel_confirm_notify: "Annuler ce rendez-vous ? Le client sera prévenu par e-mail.",
  appt_cancelled: "Rendez-vous annulé.",
  cal_kind_appointment: "Rendez-vous",
  cal_kind_event: "Événement privé",
  cal_time: "Horaire",
  cal_with_lawyer: "Avocat",
  cal_pending_hint: "Cette demande attend votre réponse : acceptez-la ou refusez-la depuis Rendez-vous.",
  cal_delete_event_confirm: "Supprimer cet événement de votre agenda ?",
  cal_event_lead: "Un moment réservé dans votre agenda (audience, réunion...) : les clients ne pourront pas réserver ce créneau.",
  cal_event_subject_hint: "Ex. : audience au tribunal de première instance",
  cal_event_hint: "Heure de Tunis.",
  cal_event_save: "Ajouter l'événement",
  cal_event_err_taken: "Ce créneau chevauche un autre rendez-vous ou événement.",
  cal_event_err_time: "Choisissez un début à venir et une fin après le début.",
  cal_event_err_generic: "L'événement n'a pas pu être ajouté, veuillez réessayer.",
  ldash_premium_text: "Votre profil est visible et les clients peuvent prendre rendez-vous avec vous en ligne.",
  ldash_free_text: "Votre profil, votre téléphone, vos horaires et votre adresse sont visibles dans l'annuaire. Essayez Pro 14 jours, sans carte, pour la prise de rendez-vous en ligne et vos dossiers.",
  case_menu: "Dossiers",
  case_title: "Dossiers",
  dl_title: "Audiences et échéances",
  dl_add: "Ajouter une échéance",
  dl_hint: "Rappel par e-mail 7 jours puis 1 jour avant. Une échéance partagée est aussi rappelée à votre client la veille.",
  dl_f_kind: "Type",
  dl_f_label: "Précision",
  dl_f_date: "Date",
  dl_f_time: "Heure",
  dl_f_location: "Lieu (tribunal, salle)",
  dl_share: "Afficher cette date à {{name}} et lui rappeler la veille",
  dl_save: "Enregistrer l'échéance",
  dl_empty: "Aucune audience ni échéance dans ce dossier.",
  dl_kind_hearing: "Audience",
  dl_kind_appeal: "Délai d'appel",
  dl_kind_filing: "Dépôt de pièces",
  dl_kind_meeting: "Rendez-vous",
  dl_kind_other: "Échéance",
  dl_done: "Fait",
  dl_mark_done: "Marquer comme fait : {{what}}",
  dl_shared: "Partagée",
  dl_shared_hint: "Visible par le client, rappel la veille",
  dl_today: "Aujourd'hui",
  dl_tomorrow: "Demain",
  dl_in_days_one: "Dans {{count}} jour",
  dl_in_days: "Dans {{count}} jours",
  dl_late_one: "En retard de {{count}} jour",
  dl_late: "En retard de {{count}} jours",
  dl_upcoming_title: "Prochaines audiences et échéances",
  dl_upcoming_empty: "Rien dans les 30 prochains jours. Ajoutez vos audiences dans vos dossiers pour être rappelé à temps.",
  dl_more: "+ {{count}} autres dans vos dossiers",
  case_notes_title: "Notes",
  pstats_deadlines_one: "{{count}} échéance cette semaine",
  pstats_deadlines: "{{count}} échéances cette semaine",
  pstats_overdue_one: "{{count}} en retard",
  pstats_overdue: "{{count}} en retard",
  mycases_dates: "Dates à retenir",
  pro_f_deadlines: "Audiences et délais",
  pro_f_deadlines_text: "Notez vos audiences et délais d'appel : rappel par e-mail 7 jours puis la veille, pour vous et, si vous le souhaitez, pour votre client.",
  pro_c_deadlines: "Rappels d'audiences et de délais",
  case_lead: "Un dossier par affaire. Les notes sont privées et chiffrées ; vous choisissez celles que votre client peut lire.",
  case_new: "Nouveau dossier",
  case_f_title: "Intitulé",
  case_f_reference: "Référence",
  case_f_category: "Domaine",
  case_f_client: "Client",
  case_f_status: "Statut",
  case_no_client: "Sans client lié",
  case_client_hint: "Seuls les clients qui ont pris rendez-vous avec vous peuvent être liés à un dossier.",
  case_create: "Créer le dossier",
  case_all: "Tous",
  case_status_open: "En cours",
  case_status_pending: "En attente",
  case_status_closed: "Clôturé",
  case_cat_civil: "Civil",
  case_cat_family: "Famille",
  case_cat_criminal: "Pénal",
  case_cat_commercial: "Commercial",
  case_cat_labor: "Travail",
  case_cat_administrative: "Administratif",
  case_cat_real_estate: "Immobilier",
  case_cat: "Autre",
  case_empty: "Aucun dossier pour le moment.",
  case_error: "L'opération a échoué. Réessayez.",
  case_back: "Tous les dossiers",
  case_note_new: "Nouvelle note",
  case_note_share: "Partager cette note avec {{name}}",
  case_note_share_no_client: "Liez un client au dossier pour pouvoir partager des notes.",
  case_note_privacy: "Notes chiffrées et couvertes par le secret professionnel. Une note partagée n'est visible que par votre client, jamais publiée ; il reçoit un e-mail sans son contenu.",
  case_note_add: "Ajouter la note",
  case_notes_empty: "Aucune note dans ce dossier.",
  case_note_shared: "Partagée avec le client",
  case_note_private: "Privée",
  case_note_do_share: "Partager avec le client",
  case_note_unshare: "Ne plus partager",
  case_delete: "Supprimer le dossier",
  case_delete_confirm: "Supprimer définitivement ce dossier et toutes ses notes ?",
  case_delete_yes: "Oui, supprimer",
  clients_menu: "Clients",
  clients_title: "Clients",
  clients_lead: "Les personnes qui ont pris rendez-vous avec vous, avec un mémo privé que vous seul voyez.",
  clients_empty: "Vos clients apparaîtront ici après leur premier rendez-vous en ligne.",
  clients_appointments_one: "{{count}} rendez-vous",
  clients_appointments: "{{count}} rendez-vous",
  clients_last: "Dernier : {{date}}",
  clients_cases: "Dossiers : {{count}} ({{open}} en cours)",
  clients_memo: "Mémo privé",
  clients_memo_save: "Enregistrer",
  clients_memo_saved: "Enregistré",
  clients_open_case: "Ouvrir un dossier",
  fb_menu: "Retours clients",
  fb_title: "Retours clients",
  fb_lead: "Ce que vos clients disent après leur consultation. Visible par vous seul : jamais publié, jamais utilisé pour classer les avocats.",
  fb_count_one: "{{count}} retour",
  fb_count: "{{count}} retours",
  fb_empty: "Aucun retour pour le moment. Vos clients peuvent en laisser un après une consultation confirmée.",
  fb_rating_one: "{{count}} étoile sur 5",
  fb_rating: "{{count}} étoiles sur 5",
  fb_give: "Donner mon avis à l'avocat",
  fb_give_title: "Comment s'est passée la consultation ?",
  fb_comment: "Un mot pour votre avocat (facultatif)",
  fb_private_note: "Visible uniquement par votre avocat. Jamais publié sur le site.",
  fb_send: "Envoyer",
  fb_given: "Avis envoyé",
  pstats_title: "Votre cabinet",
  pstats_cases_open: "Dossiers en cours",
  pstats_cases_pending: "En attente",
  pstats_cases_closed: "Clôturés",
  pstats_upcoming: "RDV à venir",
  pstats_last30: "30 derniers jours : {{opened}} ouverts, {{closed}} clôturés",
  pstats_avg_close_one: "clôture en {{count}} jour en moyenne",
  pstats_avg_close: "clôture en {{count}} jours en moyenne",
  pstats_feedback: "retours clients {{average}}/5 ({{count}})",
  pstats_open_cases: "Voir les dossiers",
  pstats_locked: "Suivez vos dossiers, vos rendez-vous et les retours de vos clients au même endroit.",
  mycases_tab: "Mes dossiers",
  mycases_empty: "Aucun dossier. Lorsque votre avocat ouvre un dossier pour vous sur AvoConsulte, vous le retrouvez ici.",
  mycases_lawyer: "Maître {{name}}",
  mycases_no_notes: "Votre avocat n'a encore rien partagé sur ce dossier.",
  ldash_last_answer: "Dernière réponse",
  // User dashboard redesign
  dash_wrong_email: "Ce n'est pas votre adresse e-mail ?",
  dash_virtual: "En ligne",
  dash_hello: "Bonjour, {{name}}",
  dash_lead: "Suivez vos rendez-vous et vos questions juridiques au même endroit.",
  dash_stat_upcoming: "Rendez-vous à venir",
  dash_stat_pending: "Questions en attente de validation",
  dash_question_sent: "Votre question a été envoyée. Elle sera publiée après validation.",
  dash_question_error: "Votre question n'a pas pu être envoyée. Réessayez.",
  dash_email_note: "L'adresse e-mail ne peut pas être modifiée depuis cette page.",
  dash_saving: "Enregistrement…",
  dash_verify_text: "Nous avons envoyé un lien de vérification à {{email}}. Ouvrez-le pour activer votre compte.",
  dash_sending: "Envoi…",
  // About & contact pages redesign
  about_title: "Qu'est-ce qu'AvoConsulte ?",
  about_lead: "AvoConsulte est une plateforme simple et rapide pour trouver un avocat près de chez vous dans l'annuaire et prendre rendez-vous avec lui.",
  about_clients_title: "Pour les clients",
  about_clients_1: "Trouvez rapidement un avocat près de chez vous et prenez rendez-vous en ligne, gratuitement.",
  about_clients_2: "Posez vos questions juridiques en ligne, directement aux avocats, en toute confidentialité.",
  about_clients_3: "Consultez les réponses déjà apportées par des avocats aux questions des autres utilisateurs.",
  about_lawyers_title: "Pour les avocats",
  about_lawyers_1: "Un outil complet de gestion de cabinet, qui améliore votre organisation et vous fait gagner du temps.",
  about_lawyers_2: "Partagez en temps réel vos disponibilités avec vos clients, selon vos critères, tout en gardant la maîtrise de votre agenda.",
  about_lawyers_3: "Échangez directement avec vos clients et répondez à leurs questions.",
  contact_eyebrow: "Contact",
  contact_title: "Nous sommes à votre écoute",
  contact_form_title: "Envoyez-nous un message",
  contact_sending: "Envoi…",
  contact_success: "Merci de nous avoir contactés. Nous vous répondrons dans les meilleurs délais.",
  contact_error: "Votre message n'a pas pu être envoyé. Réessayez plus tard ou écrivez-nous par e-mail.",
  contact_email_title: "Écrivez-nous",
  contact_find_lawyer_title: "Vous cherchez un avocat ?",
  contact_find_lawyer_text: "Parcourez l'annuaire par gouvernorat ou par nom.",
  contact_question_title: "Une question juridique ?",
  contact_question_text: "Posez-la aux avocats dans la rubrique Consultation juridique.",
  // Lawyer profile page redesign
  Maps: "Localisation du cabinet",
  profile_call: "Appeler l'avocat",
  profile_fax: "Fax",
  profile_no_online_booking: "Cet avocat ne propose pas encore la prise de rendez-vous en ligne. Vous pouvez le contacter par téléphone.",
  profile_hours_indicative: "Horaires indicatifs, à confirmer par téléphone.",
  profile_open_map: "Ouvrir dans Google Maps",
  profile_court: "Inscription",
  // Magazine & lawyers pages redesign
  magazine_eyebrow: "Articles et guides pratiques",
  magazine_author: "La rédaction AvoConsulte",
  read_article: "Lire l'article",
  back_to_magazine: "Retour au magazine",
  lawyers_eyebrow: "Annuaire des avocats",
  lawyers_title: "Avocats à {{state}}",
  lawyers_title_all: "Avocats dans toute la Tunisie",
  lawyers_change_search: "Essayez un autre nom ou cherchez dans toute la Tunisie.",
  // Home page redesign
  home_eyebrow: "L'annuaire des avocats en Tunisie",
  home_search_name_label: "Nom de l'avocat",
  home_search_city_label: "Gouvernorat",
  home_all_cities: "Toute la Tunisie",
  home_popular_cities: "Villes fréquentes",
  home_trust_states: "24 gouvernorats",
  home_trust_booking: "Prise de rendez-vous en ligne",
  home_trust_advice: "Conseils juridiques d'avocats",
  home_steps_eyebrow: "Comment ça marche",
  home_step1_title: "Trouvez un avocat",
  home_step2_title: "Prenez rendez-vous",
  home_step3_title: "Recevez un rappel",
  home_cta_title: "Vous êtes avocat ?",
  home_cta_text: "Rejoignez AvoConsulte et recevez en ligne les demandes de rendez-vous de vos clients.",
  home_cta_button: "Rejoindre AvoConsulte",
  // Home Search component
  find_lawyer_near_you: "Trouvez un avocat près de chez vous",
  find_lawyer_near_you_description:
    "Cherchez et trouvez un avocat en Tunisie et prenez rendez-vous en ligne",
  search: "Recherche",
  city: "Gouvernorat",
  based_on_your_location: "Basé sur votre position",
  ex: "exemple : nom de l'avocat",
  search_location: "Recherche par localisation",
  // Navbar component
  Home: "Accueil",
  LegalMagazine: "Magazine Juridique",
  LegalAdvice: "Consultation juridique",
  Lawyers: "Avocats",
  AboutUs: "Qui sommes-nous",
  ContactUs: "Contactez nous",
  PrivacyPolicy: "Politique de confidentialité",
  Legal_Magazine: "Magazine-Juridique",
  Legal_Advice: "Questions-Reponses",
  About_Us: "Qui-Somme-Nous",
  Contact_Us: "Contactez-Nous",
  Privacy_Policy: "Confidentialite",
  Login: "Connexion",
  arabic: "arabe",
  french: "français",
  english: "anglais",
  my_account: "Mon compte",
  nav_open_menu: "Ouvrir le menu",
  nav_close_menu: "Fermer le menu",
  nav_menu: "Menu",
  nav_language: "Langue",
  theme_label: "Affichage",
  theme_dark: "Mode sombre",
  theme_light: "Mode clair",
  footer_navigation: "Navigation",
  footer_by_city: "Avocats par gouvernorat",
  footer_your_space: "Votre espace",
  privacy_eyebrow: "Confidentialité",
  privacy_title: "Politique de confidentialité",
  privacy_lead:
    "La sécurité et la confidentialité de vos données personnelles sont une priorité absolue pour AvoConsulte.",
  privacy_intro:
    "AvoConsulte construit des relations solides et durables avec ses utilisateurs, fondées sur la confiance mutuelle. Cette page explique quelles informations sont collectées lorsque vous utilisez la plateforme et comment elles sont utilisées.",
  privacy_toc: "Sommaire",
  privacy_logs_title: "Journaux de connexion",
  privacy_logs_body:
    "AvoConsulte peut enregistrer des journaux de connexion complets : votre adresse IP, le type de navigateur, l'heure et la durée de visite, la date d'accès et les liens consultés. Ces données servent à comprendre la nature des visiteurs et à améliorer le service en continu. Elles ne sont jamais utilisées, promues ni exposées sous forme d'informations personnelles auprès des autres visiteurs ou utilisateurs.",
  privacy_cookies_title: "Cookies",
  privacy_cookies_body:
    "Nous utilisons parfois des cookies afin de connaître les préférences des visiteurs, l'historique de leurs visites et les liens consultés. Ils peuvent être conservés sans porter atteinte à la vie privée de l'abonné ni à ses informations personnelles.",
  privacy_third_title: "Sites tiers",
  privacy_third_body:
    "AvoConsulte affiche des publicités Google et utilise des services de sites tiers : vos cookies peuvent donc servir à afficher des annonces correspondant à vos centres d'intérêt. Ces sites, Google en tête, peuvent utiliser votre adresse IP pour analyser les cookies et mesurer l'efficacité des annonces. Pour comprendre ce fonctionnement ou vous y opposer, consultez les explications de Google :",
  privacy_third_link: "Paramètres des annonces Google",
  privacy_consulting_title: "Services de conseil",
  privacy_consulting_body:
    "AvoConsulte propose un service de conseil privé : l'équipe de conseillers et les autres intervenants peuvent donc prendre connaissance des faits et de l'avancement de votre dossier juridique. AvoConsulte ne publie aucune affaire ni information sur sa plateforme sans le consentement préalable des parties, grâce à l'option proposée dans la fenêtre de consultation. Les consultations privées sont envoyées à une adresse e-mail non visible du public, réservée à l'équipe de conseillers, sauf si l'abonné souhaite rendre sa question publique.",
  privacy_updates_title: "Mises à jour",
  privacy_updates_body:
    "Nous vous invitons à lire régulièrement cette politique. Pour toute question, écrivez-nous à l'adresse e-mail principale du site. Elle peut évoluer selon les instructions de notre équipe juridique : en cas de modification, nous enverrons une copie à nos abonnés ou afficherons un avis sur nos pages d'accueil.",
  privacy_contact_title: "Une question sur vos données ?",
  privacy_contact_text: "Notre équipe est à votre disposition par e-mail.",
  privacy_contact_btn: "Nous contacter",
  // Operation Center (operators' console)
  oc_title: "Centre des opérations",
  oc_login_lead: "Espace réservé à l'équipe AvoConsulte.",
  oc_email: "E-mail",
  oc_password: "Mot de passe",
  oc_continue: "Continuer",
  oc_code: "Code de vérification",
  oc_code_lead: "Saisissez le code à 6 chiffres envoyé à {{email}}.",
  oc_code_dev: "Mode développement : le code est {{code}}.",
  oc_verify: "Se connecter",
  oc_back: "Retour",
  oc_login_failed: "E-mail ou mot de passe incorrect.",
  oc_code_failed: "Code invalide ou expiré.",
  oc_network_error: "Serveur injoignable. Réessayez.",
  oc_logout: "Déconnexion",
  oc_nav_overview: "Vue d'ensemble",
  oc_nav_requests: "Demandes d'avocats",
  oc_nav_lawyers: "Avocats",
  oc_nav_users: "Utilisateurs",
  oc_nav_questions: "Questions",
  oc_refresh: "Actualiser",
  oc_search: "Rechercher",
  oc_all: "Tous",
  oc_loading: "Chargement…",
  oc_empty: "Rien à afficher.",
  oc_error: "Le chargement a échoué.",
  oc_retry: "Réessayer",
  oc_page: "Page {{page}} sur {{pages}}",
  oc_prev: "Précédent",
  oc_next: "Suivant",
  oc_results: "{{count}} résultats",
  oc_cancel: "Annuler",
  oc_confirm: "Confirmer",
  oc_reason: "Motif (envoyé par e-mail)",
  oc_reason_required: "Indiquez un motif.",
  oc_saved: "Enregistré.",
  oc_action_failed: "L'action a échoué : {{message}}",
  oc_view_profile: "Voir le profil",
  oc_status_pending: "En attente",
  oc_status_approved: "Acceptée",
  oc_status_rejected: "Refusée",
  oc_status_published: "Publiée",
  oc_status_closed: "Fermée",
  oc_ov_title: "Vue d'ensemble",
  oc_ov_updated: "Mis à jour à {{time}}",
  oc_ov_pending_requests: "Demandes d'avocats en attente",
  oc_ov_pending_questions: "Questions à valider",
  oc_ov_users: "Utilisateurs inscrits",
  oc_ov_lawyers_published: "Avocats publiés",
  oc_ov_unanswered: "Questions publiées sans réponse",
  oc_ov_appointments_pending: "Rendez-vous en attente",
  oc_ov_weekly: "Activité des 12 dernières semaines",
  oc_ov_signups: "Inscriptions",
  oc_ov_questions: "Questions posées",
  oc_ov_appointments: "Rendez-vous demandés",
  oc_ov_answers: "Réponses d'avocats",
  oc_ov_week_of: "Semaine du {{date}}",
  oc_ov_total_12w: "{{count}} en 12 semaines",
  oc_ov_show_table: "Afficher le tableau",
  oc_ov_hide_table: "Masquer le tableau",
  oc_ov_week: "Semaine",
  oc_ov_count: "Nombre",
  oc_ov_by_state: "Avocats publiés par gouvernorat",
  oc_ov_top_viewed: "Profils les plus consultés",
  oc_ov_views: "{{count}} vues",
  oc_ov_calls: "{{count}} appels",
  oc_ov_content: "Contenus",
  oc_ov_questions_status: "Questions",
  oc_ov_appointments_status: "Rendez-vous",
  oc_ov_articles: "Articles publiés",
  oc_ov_answers_total: "Réponses",
  oc_ov_clients: "Clients",
  oc_ov_lawyer_accounts: "Comptes avocats",
  oc_ov_suspended: "Comptes suspendus",
  oc_appt_pending: "En attente",
  oc_appt_confirmed: "Confirmés",
  oc_appt_cancelled: "Annulés",
  oc_req_submitted: "Demande envoyée le {{date}}",
  oc_req_reviewed: "Traitée le {{date}}",
  oc_req_account: "Compte",
  oc_req_email_verified: "E-mail confirmé",
  oc_req_email_unverified: "E-mail non confirmé",
  oc_req_no_account: "Aucun compte lié",
  oc_req_duplicates: "Déjà présent dans l'annuaire ?",
  oc_req_duplicates_lead: "Profils au nom proche : vérifiez qu'il ne s'agit pas d'un doublon.",
  oc_req_approve: "Accepter",
  oc_req_reject: "Refuser",
  oc_req_approve_confirm: "Publier ce profil dans l'annuaire et ouvrir le tableau de bord avocat ?",
  oc_req_reject_title: "Refuser la demande de {{name}}",
  oc_req_reject_lead: "Le compte redevient un compte client. Le motif est envoyé à l'avocat.",
  oc_req_note: "Note",
  oc_law_visibility: "Visibilité",
  oc_law_published: "Publié",
  oc_law_hidden: "Masqué",
  oc_law_source: "Origine",
  oc_law_source_directory: "Annuaire",
  oc_law_source_registered: "Inscription",
  oc_law_name: "Avocat",
  oc_law_state: "Gouvernorat",
  oc_law_stats: "Audience",
  oc_law_status: "Statut",
  oc_law_actions: "Actions",
  oc_law_hide: "Masquer",
  oc_law_publish: "Publier",
  oc_law_plan: "Formule",
  oc_law_plan_free: "Gratuit",
  oc_law_offer_pro: "Offrir Pro",
  oc_law_remove_pro: "Retirer Pro",
  oc_plan_trialing: "Pro · essai",
  oc_plan_active: "Pro",
  oc_plan_past_due: "Pro · impayé",
  oc_plan_comped: "Pro offert",
  oc_plan_legacy: "Pro (ancien, sans abonnement)",
  oc_plan_expired: "Gratuit (ancien Pro)",
  oc_plan_until: "jusqu'au {{date}}",
  oc_plan_ends: "se termine le {{date}}",
  oc_ov_pro_title: "Abonnements Pro",
  oc_ov_pro_mrr: "Revenu mensuel",
  oc_ov_pro_active: "Payants",
  oc_ov_pro_trialing: "En essai",
  oc_ov_pro_past_due: "Paiement en retard",
  oc_ov_pro_comped: "Offerts",
  oc_law_hide_confirm: "Retirer {{name}} de l'annuaire public ?",
  oc_law_publish_confirm: "Publier {{name}} dans l'annuaire public ?",
  oc_law_publish_warn_not_in_onat: "Attention : cet avocat ne figure pas au tableau actuel de l'ONAT (retraité, décédé ou non retrouvé). Ne le publiez que si vous avez vérifié qu'il exerce.",
  oc_law_publish_warn_left_onat: "Attention : cet avocat n'est plus inscrit comme actif au tableau de l'ONAT. Ne le publiez que si vous avez vérifié qu'il exerce.",
  oc_law_not_in_onat: "Absent du tableau ONAT",
  oc_law_left_onat: "A quitté le tableau ONAT",
  oc_user_reactivate: "Réactiver le compte",
  oc_user_reactivate_confirm: "Réactiver le compte de {{name}} ? Cette personne pourra de nouveau se connecter.",
  oc_law_search_ph: "Nom, e-mail, téléphone ou n° d'inscription",
  oc_usr_name: "Utilisateur",
  oc_usr_role: "Rôle",
  oc_usr_role_guest: "Client",
  oc_usr_role_lawyer: "Avocat",
  oc_usr_joined: "Inscrit le",
  oc_usr_activity: "Activité",
  oc_usr_activity_value: "{{questions}} questions · {{appointments}} RDV",
  oc_usr_status: "Statut",
  oc_usr_active: "Actif",
  oc_usr_suspended: "Suspendu",
  oc_usr_unverified: "E-mail non confirmé",
  oc_usr_filter_suspended: "Suspendus",
  oc_usr_filter_unverified: "E-mail non confirmé",
  oc_usr_suspend: "Suspendre",
  oc_usr_unsuspend: "Réactiver",
  oc_usr_verify: "Confirmer l'e-mail",
  oc_usr_suspend_confirm: "Suspendre le compte de {{name}} ? Il ne pourra plus se connecter.",
  oc_usr_verify_confirm: "Confirmer l'adresse e-mail de {{name}} sans le lien envoyé ?",
  oc_usr_search_ph: "Nom, e-mail ou téléphone",
  oc_q_by: "Par {{name}}",
  oc_q_answers: "{{count}} réponses",
  oc_q_publish: "Publier",
  oc_q_publish_confirm: "Publier cette question sur le site ? « {{title}} »",
  oc_q_reject: "Refuser",
  oc_q_reject_title: "Refuser la question « {{title}} »",
  oc_q_reject_lead: "La question reste privée. Le motif est envoyé à son auteur, qui peut la modifier.",
  oc_q_lang_ar: "Arabe",
  oc_q_lang_fr: "Français",
  oc_q_search_ph: "Titre ou contenu",
  oc_q_open: "Voir la page",
  oc_nav_articles: "Articles",
  oc_art_status_pending: "Brouillons",
  oc_art_status_published: "Publiés",
  oc_art_status_deleted: "Dépubliés",
  oc_art_lang_en: "Anglais",
  oc_art_search_ph: "Titre ou résumé",
  oc_art_created_on: "Rédigé le {{date}}",
  oc_art_published_on: "Publié le {{date}}",
  oc_art_unpublished_on: "Dépublié le {{date}}",
  oc_art_preview: "Aperçu de l'article",
  oc_art_hide: "Masquer l'aperçu",
  oc_art_view: "Voir sur le site",
  oc_art_unpublish: "Dépublier",
  oc_art_publish_title: "Publier « {{title}} » ?",
  oc_art_publish_lead: "L'article est mis en ligne dans le magazine, daté d'aujourd'hui s'il n'a jamais été publié.",
  oc_art_unpublish_title: "Dépublier « {{title}} »",
  oc_art_unpublish_lead: "L'article est retiré du site. Le motif est conservé pour l'équipe.",
  // Look for a lawyer component
  Why_make_an_appointment_with_AvoConsulte:
    "Pourquoi prendre un rendez-vous avec AvoConsulte ?",
  Why_make_an_appointment_with_AvoConsulte_description:
    "Avec AvoConsulte , prenez rendez-vous en ligne avec votre avocat autrement",
  LOOK_FOR_A_LAWYER: "A LA RECHERCHE D'UN AVOCAT",
  LOOK_FOR_A_LAWYER_DESCRIPTION: "Accédez rapidement à votre avocat",
  SEE_PROFILE: "VOIR LE PROFIL",
  SEE_PROFILE_DESCRIPTION: "Prenez rendez-vous en ligne à tout moment",
  TAKE_HIS_CONTACT_INFORMATION: "PRENDRE SES COORDONNÉES",
  TAKE_HIS_CONTACT_INFORMATION_DESCRIPTION:
    "Recevez des mail de rappel personnalisés",
  // Question section component
  Legal_advice: "Conseils juridiques",
  Legal_advice_description:
    "Posez votre question à l'avocat et passez en revue la liste des questions et leurs réponses.",
  View_All_question: "Afficher plus",
  Share_the_post: "Partager",
  Answers: "Réponses",
  Answer_as_a_lawyer: "Répondre en tant qu'avocat",
  Answer_Question: "Répondre à la question",
  Answer: "Répondre",
  //(home page) Blog section component
  Legal_Magazine_title: "Magazine Juridique",
  Legal_Magazine_description:
    "Le magazine juridique de notre plateforme contient des informations utiles et toutes les actualités",
  View_All_blog: "Afficher plus",
  No_content_available: "Aucun contenu disponible",
  blog_is_not_available: "Le blog n'est pas disponible",
  // footer component
  AvoConsulte: "AvoConsulte",
  All_rights_reserved: "Tous droits réservés",
  Looking_for_a_lawyer: "Vous cherchez un avocat ?",
  Register_as_Client: "Inscrivez-vous en tant que client",
  Register_as_Lawyer: "Inscrivez-vous en tant qu'avocat",
  POPULAR_SEARCHES: "RECHERCHES POPULAIRES",
  Lawyer_Tunis: "Avocat tunis",
  Lawyer_Ariana: "Avocat Ariana",
  Lawyer_Sfax: "Avocat Sfax",
  Lawyer_Sousse: "Avocat Sousse",
  Lawyer_Manouba: "Avocat Manouba",
  Lawyer_Monastir: "Avocat Monastir",
  Lawyer_Mahdia: "Avocat Mahdia",
  Lawyer_Nabeul: "Avocat Nabeul",
  Lawyer_Kairouan: "Avocat Kairouan",
  Lawyer_Kasserine: "Avocat Kasserine",
  Lawyer_Gabes: "Avocat Gabes",
  Lawyer_Medenine: "Avocat Medenine",
  Lawyer_Sidi_Bouzid: "Avocat Sidi Bouzid",
  Lawyer_Siliana: "Avocat Siliana",
  Lawyer_Gafsa: "Avocat Gafsa",
  Lawyer_Jendouba: "Avocat Jendouba",
  Lawyer_Kebili: "Avocat Kebili",
  Lawyer_Zaghouan: "Avocat Zaghouan",
  Lawyer_Bizerte: "Avocat Bizerte",
  Lawyer_Ben_arous: "Avocat ben arous",
  Lawyer_beja: "Avocat beja",
  Lawyer_Tozeur: "Avocat Touzeur",
  //Question page component
  Load_More: "Charger plus",
  Latest_Posts: "Derniers articles",
  //Lawyers page component
  No_lawyer_found: "Aucun avocat trouvé",
  View_Profile: "Voir le profil",
  Book_Appointment: "Prendre RDV",
  Search_Filter: "Recherche et filtre",
  Phone_numbers: "Numéros de téléphone",
  Lawyers_p: "Avocats",
  Description_Lawyer_p:
    "Trouvez les meilleurs avocats réservez votre rendez-vous en ligne",
  //Lawyer profile page component
  Phone_number: "Numéro de téléphone",
  Lawyer_Contact_information: "Coordonnées de l'avocat",
  Close: "Fermer",
  Not_Available: "Non disponible",
  Overview: "Aperçu",
  Business_Hours: "Heures d'ouverture",
  hours_lead: "Indiquez vos jours et heures de réception. Les clients ne pourront réserver qu'à l'intérieur de ces horaires, par rendez-vous d'une heure.",
  hours_open: "Ouvert",
  hours_morning: "Matin",
  hours_afternoon: "Après-midi",
  hours_continuous: "Horaires",
  hours_from: "de",
  hours_to: "à",
  hours_lunch_break: "Pause déjeuner",
  hours_copy_monday: "Appliquer le lundi du mardi au vendredi",
  hours_save: "Enregistrer les horaires",
  hours_saved: "Horaires enregistrés. Les créneaux de réservation sont à jour.",
  hours_save_error: "L'enregistrement a échoué. {{message}}",
  hours_error_order: "L'heure de fin doit être après l'heure de début.",
  hours_error_overlap: "L'après-midi doit commencer après la fin de la matinée.",
  booking_pick_slot: "Choisissez un créneau",
  booking_prev_week: "Semaine précédente",
  booking_next_week: "Semaine suivante",
  booking_unavailable: "indisponible",
  booking_no_slots_week: "Aucun créneau libre cette semaine. Essayez la semaine suivante.",
  booking_selected: "Créneau choisi : {{day}} {{date}}, {{time}}",
  pro_offer_title: "Gérez tout votre cabinet avec AvoConsulte Pro",
  pro_offer_lead: "Rendez-vous en ligne, agenda, dossiers clients et notes partagées, au même endroit. Moins de temps au téléphone, plus de temps pour vos dossiers.",
  pro_ended_note: "Pro est en pause sur votre compte. Vos dossiers, notes et statistiques sont conservés : reprenez Pro pour les retrouver.",
  pro_f_booking: "Rendez-vous en ligne 24h/24",
  pro_f_booking_text: "Vos clients réservent eux-mêmes dans vos heures d'ouverture, même le soir et le week-end. Vous confirmez d'un clic.",
  pro_f_agenda: "Agenda du cabinet",
  pro_f_agenda_text: "Demandes, rendez-vous confirmés et indisponibilités dans un seul calendrier.",
  pro_f_stats: "Statistiques du cabinet",
  pro_f_stats_text: "Dossiers ouverts et clôturés, rendez-vous, vues du profil et appels sur 30 jours.",
  pro_f_address: "Adresse personnalisée",
  pro_f_address_text: "Un lien court à votre nom, à partager sur vos cartes et réseaux.",
  pro_f_cases: "Dossiers clients",
  pro_f_cases_text: "Un dossier par affaire, avec référence, statut et notes privées chiffrées.",
  pro_f_shared: "Notes partagées avec le client",
  pro_f_shared_text: "Partagez une note précise (pièces à fournir, date d'audience) : votre client la lit dans son espace. Le reste reste privé.",
  pro_f_clients: "Fiche client",
  pro_f_clients_text: "Historique des rendez-vous et mémo privé pour chaque client.",
  pro_f_feedback: "Retours clients privés",
  pro_f_feedback_text: "Après chaque consultation, le client peut vous laisser un avis que vous seul lisez. Jamais publié.",
  pro_trial_no_card: "Aucune carte bancaire demandée",
  pro_trial_no_charge: "Rien ne sera débité : l'essai s'arrête seul le {{date}}",
  pro_trial_keep_data: "Abonnez-vous quand vous voulez, vous gardez tout ce que vous avez créé",
  pro_consent_after_trial: "J'ai compris : {{price}} TND seront débités aujourd'hui pour un premier mois qui commence le {{date}}, à la fin de mon essai, puis chaque mois jusqu'à ce que j'annule.",
  pro_cta_keep: "Garder Pro — {{price}} TND / mois",
  pro_fine_after_trial: "Vous ne perdez aucun jour d'essai. Paiement sécurisé via Flouci, sans engagement.",
  pro_trial_notice: "Votre essai se termine le {{date}}. Aucune carte n'est enregistrée et rien ne sera débité : sans abonnement, votre compte repasse simplement au plan gratuit.",
  pro_c_phone: "Numéro de téléphone",
  pro_c_office: "Adresse du cabinet",
  pro_c_cases: "Dossiers clients et notes privées",
  pro_c_shared: "Notes partagées avec vos clients",
  pro_c_clients: "Fiches clients et mémos",
  pro_c_feedback: "Retours clients privés",
  pro_compare_note: "L'ordre de l'annuaire et les suggestions d'avocats ne dépendent jamais du plan : ils suivent le tableau de l'Ordre.",
  booking_tag: "Rendez-vous en ligne",
  pro_per_month: "TND / mois",
  pro_roi: "Moins de 2 TND par jour, sans engagement.",
  pro_consent_paid: "J'ai compris : {{price}} TND seront débités aujourd'hui, puis chaque mois jusqu'à ce que j'annule.",
  pro_cta_trial: "Essayer Pro gratuitement {{days}} jours",
  pro_cta_paid: "S'abonner à Pro — {{price}} TND / mois",
  pro_fine_paid: "Paiement sécurisé via Flouci. Sans engagement : annulez à tout moment, Pro reste actif jusqu'à la fin du mois payé.",
  pro_test_mode: "Mode test : aucun paiement réel, Flouci n'est pas encore connecté.",
  pro_compare_title: "Gratuit ou Pro",
  pro_plan_free: "Gratuit",
  pro_c_profile: "Profil dans l'annuaire",
  pro_c_hours: "Heures d'ouverture",
  pro_c_answers: "Répondre aux questions juridiques",
  pro_c_booking: "Prise de rendez-vous en ligne",
  pro_c_agenda: "Agenda et gestion des demandes",
  pro_c_stats: "Statistiques du cabinet et du profil",
  pro_c_address: "Adresse personnalisée",
  pro_yes: "Inclus",
  pro_no: "Non inclus",
  pro_status_trialing: "Essai gratuit en cours — encore {{count}} j",
  pro_status_active: "Vous êtes Pro",
  pro_status_canceling: "Pro jusqu'au {{date}}",
  pro_status_past_due: "Paiement en attente",
  pro_status_comped: "Pro offert par AvoConsulte",
  pro_next_charge: "Prochain paiement : {{price}} TND le {{date}} sur {{card}}.",
  pro_canceling_notice: "Votre abonnement ne sera pas renouvelé et rien ne sera débité. Vous gardez Pro jusqu'au {{date}}.",
  pro_past_due_notice: "Le paiement de {{price}} TND a été refusé. Mettez à jour votre carte avant le {{date}} pour garder Pro ; nous réessayons aussi chaque jour.",
  pro_comped_notice: "L'équipe AvoConsulte vous offre Pro. Aucun paiement ne vous sera demandé.",
  pro_card_on_file: "Carte enregistrée : {{card}}",
  pro_update_card: "Changer de carte",
  pro_resume: "Reprendre mon abonnement",
  pro_cancel: "Annuler l'abonnement",
  pro_cancel_confirm: "Annuler ? Pro reste actif jusqu'au {{date}}, puis ne sera pas renouvelé.",
  pro_cancel_yes: "Oui, annuler",
  pro_cancel_keep: "Garder Pro",
  pro_cancel_done: "Annulation enregistrée. Un e-mail de confirmation vous a été envoyé.",
  pro_resume_done: "Votre abonnement continue.",
  pro_welcome_trial: "Bienvenue dans Pro ! Vos {{days}} jours d'essai ont commencé, sans carte et sans engagement. Un e-mail récapitulatif vous a été envoyé.",
  pro_welcome_paid: "Bienvenue dans Pro ! Votre paiement a été accepté.",
  pro_card_failed: "La carte n'a pas pu être vérifiée.",
  pro_checkout_unavailable: "Le paiement en ligne n'est pas disponible pour le moment.",
  pro_action_failed: "L'action a échoué. Réessayez.",
  err_too_many_requests: "Trop de tentatives en peu de temps. Patientez un peu, puis réessayez.",
  lawyer_registry_fields_note: "Votre nom et votre gouvernorat proviennent du tableau de l'ONAT et ne peuvent pas être modifiés ici. Pour les corriger, contactez-nous.",
  pro_load_error: "Impossible de charger votre abonnement. Réessayez plus tard.",
  pro_confirming: "Vérification…",
  pro_invoices: "Paiements",
  pro_inv_date: "Date",
  pro_inv_period: "Période",
  pro_inv_amount: "Montant",
  pro_inv_status: "Statut",
  pro_inv_paid: "Payé",
  pro_inv_failed: "Refusé",
  pro_payment_soon_title: "Paiement en ligne bientôt disponible",
  pro_payment_soon: "L'abonnement Pro en ligne arrive bientôt : le paiement par carte n'est pas encore ouvert. Aucun montant ne vous sera demandé d'ici là.",
  pro_banner_trial_ending_free: "Votre essai Pro se termine dans {{count}} j, le {{date}}. Votre compte repassera ensuite au plan gratuit, sans aucun débit.",
  pro_err_card_declined: "La carte a été refusée par la banque.",
  pro_err_card_expired: "La carte est expirée.",
  pro_err_payment_failed: "Le paiement a été refusé par la banque. Aucun montant n'a été débité ; vous pouvez réessayer avec une autre carte.",
  pro_err_in_progress: "Un paiement est déjà en cours de traitement. Patientez quelques minutes avant de réessayer.",
  pro_err_session: "Cette session de paiement a expiré. Recommencez depuis votre tableau de bord.",
  pro_err_already_pro: "Vous avez déjà Pro.",
  pro_err_trial_used: "L'essai gratuit a déjà été utilisé sur ce profil.",
  pro_err_trial_not_cancelable: "L'essai gratuit s'arrête de lui-même, sans aucun débit : rien à annuler.",
  pro_err_no_subscription: "Aucun abonnement en cours.",
  pro_err_profile: "Votre profil d'avocat doit d'abord être validé par l'équipe.",
  pro_inv_pending: "En cours",
  pro_inv_checking: "En vérification",
  pro_banner_trial_ending: "Votre essai Pro se termine dans {{count}} j, le {{date}}. Abonnez-vous pour garder vos rendez-vous en ligne et vos dossiers ({{price}} TND / mois).",
  pro_banner_past_due: "Paiement Pro refusé. Mettez à jour votre carte avant le {{date}} pour garder vos avantages.",
  pro_banner_manage: "Gérer",
  pro_menu_subscription: "Mon abonnement Pro",
  pro_menu_upgrade: "Passer à Pro",
  pro_locked_hint: "Inclus dans AvoConsulte Pro",
  pro_stats_title: "Votre audience sur 30 jours",
  pro_stats_views: "Vues du profil",
  pro_stats_calls: "Appels",
  pro_stats_bookings: "Demandes de RDV",
  pro_stats_locked: "Découvrez combien de clients consultent votre profil, vous appellent et demandent un rendez-vous.",
  pro_stats_unlock: "Débloquer avec Pro",
  pro_stats_note: "Comparé aux 30 jours précédents.",
  pro_sbx_banner: "Mode test — aucun paiement réel. Cette page sera remplacée par celle de Flouci.",
  pro_sbx_title: "Vérification de votre carte",
  pro_sbx_lead: "Le premier mois est débité dès que la carte est vérifiée. Vous pouvez annuler à tout moment.",
  pro_sbx_card_number: "Numéro de carte",
  pro_sbx_expiry: "Expiration",
  pro_sbx_name: "Nom sur la carte",
  pro_sbx_submit: "Vérifier ma carte",
  pro_sbx_test_cards: "Cartes de test",
  pro_sbx_card_ok: "acceptée",
  pro_sbx_card_fails_later: "acceptée, mais les paiements échouent",
  pro_sbx_card_declined: "refusée",
  no_further_information: "Il n'y a pas d'autres informations sur",
  No_busniess_hours_specified: "Aucune heure d'ouverture spécifiée",
  Open_Now: "Ouvert actuellement",
  Closed_Now: "Fermé actuellement",
  Closed: "Fermé",
  appel: "Avocat à la Cour d'appel",
  cassation: "Avocat à la cour de cassation",
  permiere: "Avocat en première instance",
  premiere: "Avocat en première instance",
  Today: "Aujourd'hui",
  Education: "Travail et Education",
  Services: "Prestations de service",
  //About us page component
  What_is_AvoConsulte: "Qu'est-ce que AvoConsulte ?",
  Avoconsulte_AboutUs_p1:
    "Avoconsulte est une plateforme simple et rapide pour prendre rendez-vous avec un avocat disponible près de chez vous depuis l'annuaire des avocats pour répondre à vos besoins",
  For_customers: "Pour les clients",
  For_customers_p1:
    "AvoConsulte est une plateforme innovante qui vous permet de trouver rapidement un avocat près de chez vous et de prendre rendez-vous en ligne gratuitement.",
  For_customers_p2:
    "AvoConsulte vous permet de poser vos questions en ligne directement aux avocats en respectant les conditions de confidentialité.",
  For_customers_p3:
    "AvoConsulte vous permet de trouver en ligne une réponse à vos questions auxquelles répondent directement des avocats qualifiés.",
  For_legal_professionals: "Pour les professionnels juridiques",
  For_legal_professionals_p1:
    "AvoConsulte est un service complet de gestion de cabinet d'avocats qui améliore votre organisation et vous fait gagner du temps.",
  For_legal_professionals_p2:
    ", service complet de gestion de cabine, vous partagez en temps réel avec vos clients vos disponibilités selon vos critères, tout en gardant la maîtrise de votre agenda statutaire, en améliorant votre organisation et en vous faisant gagner du temps.",
  For_legal_professionals_p3:
    "vous permet de communiquer directement avec les clients et de répondre à leurs questions.",
  With: "Avec",
  Testimonials: "Témoignages",
  Checkout_what_people_think_about_Us:
    "Vérifiez ce que les gens pensent de nous",
  Contact_us_for_further_information_or_assistance:
    "Contactez-nous pour plus d'informations ou de soutien",
  Email: "Email",
  Phone: "Téléphone",
  Location: "Emplacement",
  Get_in_touch: "Nous contacter",
  Your_Name: "Votre nom",
  Your_Email: "Votre email",
  Subject: "Sujet",
  Message: "Message",
  Send_Message: "Envoyer le message",
  Thank_you_for_reaching_out_to_us: "Merci d'avoir contacté nous",
  //login page component
  Password: "Mot de passe",
  Forgot_Password: "Mot de passe oublié?",
  or: "ou",
  Dont_have_an_account: "Vous n'avez pas de compte?",
  Are_you_a_Lawyer: "Êtes-vous un avocat ?",
  Register_here: "S'inscrire",
  login_password_Required: "Mot de passe requis",
  login_email_Required: "Email requis",
  login_email_Invalid: "Email invalide",
  login_failed: "Echec de connexion",
  //register page component
  Register: "S'inscrire",
  Mobile_Number: "Numéro de téléphone",
  Create_Password: "Créer un mot de passe",
  Confirm_Password: "Confirmer le mot de passe",
  Already_have_an_account: "Vous avez déjà un compte?",
  Signup: "S'inscrire",
  Full_Name: "Nom complet",
  First_Name: "Prénom",
  Last_Name: "Nom",
  Date_of_birth: "Date de naissance",
  register_first_Name_Required: "Le prénom est obligatoire",
  register_last_Name_Required: "Le nom est obligatoire",
  register_email_Invalid: "L'adresse email est invalide",
  register_email_Required: "L'adresse email est obligatoire",
  register_password_MinLength:
    "Le mot de passe doit contenir au moins 8 caractères",
  register_password_Required: "Le mot de passe est obligatoire",
  register_passwordMatch: "Les mots de passe ne correspondent pas",
  register_confirm_Password_Required:
    "La confirmation du mot de passe est obligatoire",
  register_dob_Required: "La date de naissance est obligatoire",
  Register_failed: "Echec de l'inscription",
  This_email_is_linked_to_another_account:
    "Cet email est lié à un autre compte",
  Required: "Requis",
  //Dashboard
  your_profile_has_been_updated_successfully:
    "Votre profil a été mis à jour avec succès",
  error_occurred_while_updating_your_profile:
    "Une erreur s'est produite lors de la mise à jour de votre profil",
  Dashboard: "Tableau de bord",
  My_Dashboard: "Mon tableau de bord",
  Profile_Settings: "Paramètres du profil",
  photo_uploading: "Envoi de la photo…",
  photo_error_type: "Image illisible. Choisissez une photo JPG, PNG ou WebP.",
  photo_error_upload: "La photo n'a pas pu être envoyée. Réessayez.",
  Logout: "Déconnexion",
  Appointments: "Rendez-vous",
  My_Questions: "Mes questions",
  Ask_Question: "Poser une question",
  Appt_Date: "Date RDV",
  Booking_Date: "Date de réservation",
  Booking_type: "Type de réservation",
  Status: "Statut",
  Lawyer: "Avocat",
  You_havent_book_any_appointmen_yet: "Vous n'avez pas réservé de rendez-vous",
  You_havent_asked_any_question_yet: "Vous n'avez pas posé de question",
  Question_Title: "Titre de la question",
  Question_Description: "Description de la question",
  ID: "ID",
  Date: "Date",
  Title: "Titre",
  Password_Security: "Sécurité et mot de passe",
  Old_password: "Ancien mot de passe",
  enter_your_old_password: "Entrez votre ancien mot de passe",
  New_password: "Nouveau mot de passe",
  enter_your_new_password: "Entrez votre nouveau mot de passe",
  Confirm_new_password: "Confirmer le nouveau mot de passe",
  confirm_your_new_password: "Confirmez votre nouveau mot de passe",
  Save_Changes: "Enregistrer les modifications",
  Personal_Information: "Informations personnelles",
  Services_and_Educations_Information: "Services et éducation",
  Update: "Mise à jour",
  View: "Voir",
  Accept: "Accepter",
  Cancel: "Annuler",
  Edit: "Modifier",
  Delete: "Supprimer",
  Review: "La revue",
  password_has_been_changed_successfully:
    "Le mot de passe a été changé avec succès",
  error_occurred_while_changing_your_password:
    "Une erreur s'est produite lors du changement de votre mot de passe",
  Change_Password: "Modifier le mot de passe",
  pending: "en attente",
  accepted: "accepté",
  confirmed: "confirmé",
  rejected: "rejeté",
  cancelled: "annulé",
  Edite_Question: "Modifier la question",
  Become_Lawyer: "Devenir un avocat",
  Name_in_arabic: "Nom en arabe",
  Name_in_french: "Nom en français",
  Address_in_arabic: "Adresse en arabe",
  Address_in_french: "Adresse en français",
  Delegation: "delegation",
  Ask_Another_Question: "Poser une autre question",
  your_account_is_under_review: "Votre compte est en cours de révision",
  review_your_application:
    "vous recevrez un e-mail dès que nous examinerons votre candidature, merci d'avoir fait appel à nos services",
  error_occurred_while_submitting_your_application:
    "Une erreur s'est produite lors de la soumission de votre candidature",
  lawyer_apply_email_taken:
    "Cet e-mail est déjà utilisé par un profil d'avocat de l'annuaire. Contactez-nous pour le récupérer.",
  lawyer_apply_profile_exists:
    "Ce compte a déjà un profil d'avocat.",
  Check_your_email_for_the_verification_link:
    "Vérifiez votre e-mail pour le lien de vérification",
  Verify_your_account_please: "Vérifiez votre compte, s'il vous plaît",
  //Account verification
  Your_account_has_been_verified_successfully:
    "Votre compte a été vérifié avec succès",
  error_occurred_while_verifying_your_account:
    "Une erreur s'est produite lors de la vérification de votre compte",
  verifying: "vérification",
  verification: "vérification",
  very_nice_you_made_it: "Très beau, vous avez réussi",
  go_to_login: "Aller à la page de connexion",
  this_is_not_your_correct_email: "Ce n'est pas votre adresse email correcte",
  Change_email: "Changer l'email",
  you_are_already_using_this_email: "Vous utilisez déjà cette adresse email",
  something_went_wrong_please_try_again:
    "Quelque chose s'est mal passé, veuillez réessayer",
  //lawyer dashboard
  profile_update_failed: "Echec de la mise à jour du profil",
  profile_update_success: "Profil mis à jour avec succès",
  Social_Media: "Réseaux sociaux",
  Messages: "Messages",
  Accounts: "Comptes",
  Invoices: "Factures",
  Available_Timings: "Heures de travail",
  Schedule_Timings: "Calendrier",
  Clients: "Clients",
  Today_Appointments: "Rendez-vous aujourd'hui",
  My_Answers: "Mes réponses",
  You_dont_have_any_appointmen_yet: "Vous n'avez pas de rendez-vous",
  Today_Clients: "Clients aujourd'hui",
  Total_Clients: "Total des clients",
  Appoinments: "Les rendez-vous",
  You_havent_answered_any_question_yet:
    "Vous n'avez répondu à aucune question pour le moment",
  Appointment_Details: "Détails du rendez-vous",
  End_Time: "Heure de fin",
  Start_Time: "Heure de début",
  you_dont_have_any_appointment: "Vous n'avez pas de rendez-vous",
  Till_Today: "Jusqu'à aujourd'hui",
  in_Person: "En personne",
  Client: "Client",
  add_event: "Ajouter un événement",
  startDate: "Date de début",
  endDate: "Date de fin",
  //booking page
  Book_now: "Réserver maintenant",
  Monday: "Lundi",
  Tuesday: "Mardi",
  Wednesday: "Mercredi",
  Thursday: "Jeudi",
  Friday: "Vendredi",
  Saturday: "Samedi",
  Sunday: "Dimanche",
  Thank_You: "Merci",
  error_while_schudling_your_appointement:
    "Une erreur s'est produite lors de la planification de votre rendez-vous",
  subject_is_required: "Le sujet est obligatoire",
  description_is_required: "La description est obligatoire",
  time_is_required: "L'heure est obligatoire",
  Booking_information: "Informations de réservation",
  //thank you page
  Appointment_booked_Successfully: "Rendez-vous réservé avec succès",
  //lawyer register page
  Full_name: "Nom complet",
  Adress: "Adresse",
  phone_number: "Numéro de téléphone",
  office_phone: "Téléphone fixe",
  court: "Tribunal",
  state: "Gouvernorat",
  cour_d_appel: "Tribunal Cour d'appel",
  cour_de_cassation: "Tribunal Cour de cassation",
  cour_a_la_permiere: "Tribunal Cour de première instance",
  register_full_Name_Required: "Le nom complet est obligatoire",
  register_Adress_Required: "L'adresse est obligatoire",
  register_phone_Required: "Le numéro de téléphone est obligatoire",
  register_office_Required: "Le numéro de bureau est obligatoire",
  register_court_Required: "Le tribunal est obligatoire",
  register_state_Required: "Le Gouvernorat est obligatoire",
  Choose_court: "Choisissez le tribunal",
  Lawyer_account_request: "Demande de compte d'avocat",
  Submit_Request: "Soumettre la demande",
  document_upload: "Télécharger le document",
  My_Lawyer_Account: "Mon compte d'avocat",
  About_Me: "À propos de moi",
  bref_description: "Description brève",
  //States
  Choose_delegation: "Choisissez la délégation",
  Choose_state: "Choisissez un gouvernorat",
  Tunis: "Tunis",
  Ariana: "Ariana",
  Ben_Arous: "Ben Arous",
  Mannouba: "Mannouba",
  Sousse: "Sousse",
  Sfax: "Sfax",
  Nabeul: "Nabeul",
  Sidi_Bouzid: "Sidi Bouzid",
  Beja: "Beja",
  Tozeur: "Tozeur",
  Monastir: "Monastir",
  Mahdia: "Mahdia",
  Bizerte: "Bizerte",
  Kasserine: "Kasserine",
  Jendouba: "Jendouba",
  Kef: "Kef",
  Medenine: "Médenine",
  Kairouan: "Kairouan",
  Gabes: "Gabes",
  Kebili: "Kebili",
  Zaghouan: "Zaghouan",
  Siliana: "Siliana",
  Tataouine: "Tataouine",
  Gafsa: "Gafsa",
  //membership
  membership: "Abonnement",
  you_have_premium_membership: "Vous avez un abonnement premium",
  you_have_free_membership: "Vous avez un abonnement gratuit",
  thank_you_for_choosing_avoconsulte: "Merci d'avoir choisi AvoConsulte",
  // Editorial FAQ, topic pages and internal links
  faq_editorial_badge: "Réponse de l'équipe éditoriale AvoConsulte",
  faq_editorial_team: "L'équipe éditoriale AvoConsulte",
  faq_editorial_note: "Cette réponse est rédigée par l'équipe éditoriale d'AvoConsulte, pas par un avocat. Elle donne des informations générales et ne remplace pas l'avis d'un avocat qui étudie votre situation.",
  faq_related_guide: "Lire le guide complet",
  faq_more_in_topic: "Autres questions sur ce thème",
  faq_ask_own: "Posez votre propre question",
  faq_ask_own_text: "Votre situation est différente ? Posez votre question aux avocats inscrits sur la plateforme.",
  find_lawyer_title: "Trouver un avocat dans votre ville",
  find_lawyer_text: "L'annuaire des avocats inscrits à l'Ordre national, par gouvernorat.",
  find_lawyer_all: "Tous les avocats en Tunisie",
  related_title: "À lire aussi",
  related_kind_guide: "Guide",
  related_kind_faq: "Question fréquente",
  sources_title: "Sources",
  sources_new_tab: "(ouvre un nouvel onglet)",
  article_last_updated: "Dernière mise à jour",
  read_in: "Lire en :",
  topic_label: "Thème",
  topics_title: "Thèmes",
  topic_guides: "Guides",
  topic_faq: "Questions fréquentes",
  oc_q_editorial: "Éditorial",
  oc_q_editorial_only: "FAQ éditoriale uniquement",
  oc_q_kind: "Type",
  oc_q_kind_visitors: "Questions des visiteurs",
  oc_q_editorial_answer: "Réponse de l'équipe éditoriale",
  oc_q_editorial_by: "Équipe éditoriale AvoConsulte",
  oc_q_lang_en: "Anglais",
  page_loading: "Chargement…",
};
